/*
 * @Author: zouyaoji@https://github.com/zouyaoji
 * @Date: 2022-03-09 15:50:51
 * @LastEditTime: 2022-03-09 15:50:53
 * @LastEditors: zouyaoji
 * @Description:
 * @FilePath: \vue-cesium@next\packages\components\overlays\wind\grid\consts.js
 */
export const π = Math.PI
export const τ = 2 * π
export const DEG = 360 / τ
export const RAD = τ / 360

export const MILLI = 1
export const SECOND = 1000 * MILLI
export const MINUTE = 60 * SECOND
export const HOUR = 60 * MINUTE
export const DAY = 24 * HOUR

export const NIL = 7e37
